// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export var HistoricalVolatilityPriceType;
(function (HistoricalVolatilityPriceType) {
    HistoricalVolatilityPriceType[HistoricalVolatilityPriceType["Last"] = 0] = "Last";
    HistoricalVolatilityPriceType[HistoricalVolatilityPriceType["BidAsk"] = 1] = "BidAsk";
    HistoricalVolatilityPriceType[HistoricalVolatilityPriceType["OHLC"] = 2] = "OHLC";
    HistoricalVolatilityPriceType[HistoricalVolatilityPriceType["OHL"] = 3] = "OHL";
})(HistoricalVolatilityPriceType || (HistoricalVolatilityPriceType = {}));
export function getHistoricalVolatilityPriceTypeKey(value) {
    switch (value) {
        case HistoricalVolatilityPriceType.Last:
            return 'property.Last';
        case HistoricalVolatilityPriceType.BidAsk:
            return 'property.BidAskAverage';
        case HistoricalVolatilityPriceType.OHLC:
            return 'property.OHLCAverage';
        case HistoricalVolatilityPriceType.OHL:
            return 'property.OHLAverage';
        default:
            return '';
    }
}
